import { render } from "./MDrop.vue?vue&type=template&id=5da1c7ca&scoped=true"
import script from "./MDrop.vue?vue&type=script&lang=js"
export * from "./MDrop.vue?vue&type=script&lang=js"

import "./MDrop.vue?vue&type=style&index=0&id=5da1c7ca&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da1c7ca"]])

export default __exports__